<template>
	<div>
		<Header />
		<div class="banner_container">
			<el-carousel trigger="click">
				<el-carousel-item v-for="(item, index) in bannerImageLi" :key="index">
					<img :src="item.src" :style="{ objectFit: 'cover' }" alt="" @click="goBannerDetail(index)"/>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="product_items_container" style="margin-top: 50px">
			<div class="product_items m">
				<h2>{{titleOne}}</h2>
				<p>{{titleOneEng}}</p>
				<ul class="pc_ul hide" style="margin-top: 60px">
					<li v-for="(item, index) in productCenter" :key="item.id">
						<!-- {{ item }} -->
						<router-link
							tag="div"
							:to="{
								path:item.id,
								params: { active: index + 1 },
							}"
						>
							<div class="photo">
								<img :src="item.src" alt="" />
							</div>
							<p
								style="
									position: relative;
									top: -187px;
									font-size: 22px;
									text-align: center;
									-zindex: 2;
									color: white;
									font-weight: bold;
								"
							>
								{{ item.title }}
							</p>
							<div
								class="demo"
								style="
									position: relative;
									top: -379px;
									z-index: 10;
									width: 100%;
									height: 350px;
									text-align:center;
									background: rgba(0, 0, 0, 0.5);
								"
							>
								<p class="product_title">{{ item.title }}</p>
								<p class="product_introduce">{{ item.description }}</p>
							</div>
						</router-link>
					</li>
				</ul>
				<ul class="m_ul show">
					<li v-for="(item, index) in productCenter" :key="item.id">
						<router-link
							tag="div"
							:to="{
								path: '/product/productdetail/' + item.id,
								params: { active: index + 1 },
							}"
						>
							<div class="photo">
								<img :src="item.src" alt="" />
							</div>
							<div class="demo">
								<p class="product_title">{{ item.title }}</p>
								<p class="product_introduce">{{ item.description }}</p>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>

		<div class="solution_container_x">
			<div class="solution m" style="margin-top: 30px">
				<h2>{{titleTwo}}</h2>
				<p>{{titleTwoEng}}</p>
				<ul class="pc_ul hide" style="margin-top: 50px">
					<li v-for="(item, index) in solution" :key="item.bd_atpid">
						<router-link
							tag="div"
							:to="{
								path:'/solution/solutiondetail/' + item.bd_atpid,
								params: { active: index + 1 },
							}"
						>
							<div class="photo">
								<img :src="item.bd_coverpicturecn" alt="" />
							</div>
							<p
								style="
									position: relative;
									top: -188px;
									font-size: 22px;
									text-align: center;
									-zindex: 2;
									color: white;
									font-weight: bold;
								"
							>
								{{ item.bd_titlecn }}
							</p>
							<div
								class="demo"
								style="
									position: relative;
									top: -379px;
									z-index: 2;
									width: 100%;
									height: 350px;
									background: rgba(0, 0, 0, 0.5);
								"
							>
								<p class="product_title">{{ item.bd_titlecn }}</p>
								<p class="product_introduce">{{ item.bd_desccn }}</p>
							</div>
						</router-link>
					</li>
				</ul>
				<ul class="m_ul show">
					<li v-for="(item, index) in solution" :key="item.bd_atpid">
						<router-link
							tag="div"
							:to="{
								path:'/solution/solutiondetail/' + item.bd_atpid,
								params: { active: index + 1 },
							}"
						>
							<div class="photo">
								<img :src="item.bd_coverpicturecn" alt="" />
							</div>
							<div class="demo">
								<p class="product_title">{{ item.bd_titlecn }}</p>
								<p class="product_introduce">{{ item.bd_desccn }}</p>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
		<div class="news_container_x">
			<div class="news_x">
				<div class="dis_flex">
						<h2>{{titleThree}}</h2>
						<p>{{titleThreeEng}}</p>
				</div>
				<div class="news_content" style="margin-top: 50px;">
					<ul style="width:100%;display:flex;flex-wrap:wrap;justify-content:space-around;">
						<li class="list_one">
							<router-link :to="`/home/news/${new_list_left[0].bd_atpid}`">
							<div class="top_img">
								<img :src="image_one" alt="" width="355px" height="200px"/>
							</div>
							<div class="first_new">
								<p class="title_one">{{new_list_left[0].bd_titlecn}}</p>
								<p class="title_two">发布时间：{{new_list_left[0].bd_atpcreatedatetime}}</p>
								<p class="title_three">{{new_list_left[0].bd_desccn}}</p>
							</div>
							</router-link>
						</li>
						<li class="list_one">
							<router-link :to="`/home/news/${new_list_left[1].bd_atpid}`">
							<div class="top_img">
								<img :src="image_two" alt="" width="355px" height="200px"/>
							</div>
							<div class="first_new">
								<p class="title_one">{{new_list_left[1].bd_titlecn}}</p>
								<p class="title_two">发布时间：{{new_list_left[1].bd_atpcreatedatetime}}</p>
								<p class="title_three">{{new_list_left[1].bd_desccn}}</p>
							</div>
							</router-link>
						</li>
						<li class="list_two">
							<ul style="padding:10px 20px;">
								<li
								class="news_items"
								v-for="item in new_list"
								:key="item.bd_atpid"
							>
								<div class="news_text_r">
									<router-link :to="`/home/news/${item.bd_atpid}`">
										<p class="news_title" style="font-size:14px;
												font-weight:bold;
												line-height:18px;
												margin-top:20px; 
												text-overflow: -o-ellipsis-lastline;
												overflow: hidden;
												text-overflow: ellipsis;
												display: -webkit-box;
												-webkit-line-clamp: 2;
												line-clamp: 2;
												-webkit-box-orient: vertical;">
											<img
												style="margin-top: -2px; vertical-align: middle;height:14px;width:38.5px"
												src="../../assets/hot_icon.jpg"
												alt=""
											/>
											{{ item.bd_titlecn }}
										</p>
										<p class="news_dateOne" style="margin-top:5px;padding-bottom:5px;text-align:right;font-size:12px">发布时间：{{
											item.bd_atpcreatedatetime
										}}</p>
									</router-link>
								</div>
							</li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="more_news">
					<router-link to="/home/news">
						<p>更多新闻&gt;</p>
					</router-link>
				</div>
			</div>
		</div>
		<div
			class="company_introduction_x"
			style="margin-top: 0px; padding-bottom: 0px; padding-top: 40px"
		>
			<div class="company_x">
				<div class="dis_flex">
					<h2>{{titleFour}}</h2>
					<p style="color:#ccc">{{titleFourEng}}</p>
				</div>
				<div class="news_content" style="margin-top: 30px">
					<ul class="pc_ul" style="margin-top: 50px">
						<li style="cursor: pointer">
							<router-link
								tag="div"
								:to="{
									path: '/investor',
								}"
							>
								<div class="photo">
									<img :src="src1" alt="" />
								</div>
								<div class="foot_master">
									<p
										style="
											position: relative;
											top: 10px;
											font-size: 16px;
											text-align: center;
											-zindex: 5;
											color: #363636;
											font-weight: bold;
										"
										class="title"
									>
										公司简介
									</p>
									<p
										class="text"
										style="
											padding: 10px 20px;
											text-align:center;
											height: 30px;
											font-size: 14px;
											overflow: hidden;
											text-overflow: ellipsis;
											display: -webkit-box;
											-webkit-line-clamp: 2;
											margin-top: 5px;
											-webkit-box-orient: vertical;
										"
									>
										{{ introduceText1 }}
									</p>
								</div>
							</router-link>
						</li>
						<li style="cursor: pointer">
							<router-link
								tag="div"
								:to="{
									path: '/join',
								}"
							>
								<div class="photo">
									<img :src="src4" alt="" />
								</div>
								<div class="foot_master">
									<p
										class="title"
										style="
											position: relative;
											top: 10px;
											font-size: 16px;
											text-align: center;
											-zindex: 5;
											color: #363636;
											font-weight: bold;
										"
									>
										业绩报告
									</p>
									<p  
									    class="text"
										style="
											padding: 10px 20px;
											text-align:center;
											height: 30px;
											font-size: 14px;
											overflow: hidden;
											text-overflow: ellipsis;
											display: -webkit-box;
											-webkit-line-clamp: 2;
											margin-top: 5px;
											-webkit-box-orient: vertical;
										"
									>
										{{ introduceText3 }}
									</p>
								</div>
								</router-link>
						</li>
						<li style="cursor: pointer">
							<router-link
								tag="div"
								:to="{
									path: '/unionparty',
								}"
							>
								<div class="photo">
									<img :src="src3" alt="" />
								</div>
								<div class="foot_master">
									<p
										class="title"
										style="
											position: relative;
											top: 10px;
											font-size: 16px;
											text-align: center;
											-zindex: 5;
											color: #363636;
											font-weight: bold;
										"
									>
										党建工会
									</p>
									<p
										class="text"
										style="
											padding: 10px 20px;
											text-align:center;
											height: 30px;
											font-size: 14px;
											overflow: hidden;
											text-overflow: ellipsis;
											display: -webkit-box;
											-webkit-line-clamp: 2;
											margin-top: 5px;
											-webkit-box-orient: vertical;
										"
									>
										{{ introduceText4 }}
									</p>
								</div>
							</router-link>
						</li>
						<li style="cursor: pointer">
							<router-link
								tag="div"
								:to="{
									path: '/company',
								}"
							>
								<div class="photo">
									<img :src="src2" alt="" />
								</div>
								<div class="foot_master">
									<p
										style="
											position: relative;
											top: 10px;
											font-size: 16px;
											text-align: center;
											-zindex: 5;
											color: #363636;
											font-weight: bold;
										"
										class="title"
									>
										加入我们
									</p>
									<p
										class="text"
										style="
											padding: 10px 20px;
											height: 30px;
											font-size: 14px;
											text-align:center;
											overflow: hidden;
											text-overflow: ellipsis;
											display: -webkit-box;
											-webkit-line-clamp: 2;
											margin-top: 5px;
											-webkit-box-orient: vertical;
										"
									>
										{{ introduceText2 }}
									</p>
								</div>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="cooperative_container_x">
			<div class="cooperative">
				<!-- <div> -->
				<h2>{{titleFive}}</h2>
				<p>{{titleFiveEng}}</p>
				<div>
					<ul>
						<li>
							<div v-for="(item, index) in parterList" :key="index">
								<img :src="item.src" alt="" />
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<Footer />
		<!-- m_弹窗 -->
		<div class="m_alert_box" v-show="isAlert">
			<i
				class="m_alert_close"
				@click="
					() => {
						this.isAlert = false
					}
				"
				>×</i
			>
			<div class="m_alert_box_txt">欢迎来到本网站，请问有什么可以帮您？</div>
			<div class="m_alert_box_btns">
				<div @click="leaving">现在咨询</div>
				<div
					@click="
						() => {
							this.isAlert = false
						}
					"
				>
					稍后再说
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import Title from '../../components/Title.vue'
import Axios from 'axios'

export default {
	components: {
		Header,
		Footer,
		Title,
	},
	data() {
		return {
			performance:'',
			isAlert: false,
			timer: null,
			bannerImageLi: [],
			new_list: [],
			value1: false,
			solution: [],
			news_data: {
				introduce: '一段文字介绍',
				news_list: [],
			},
			src1: '',
			src2: '',
			src3: '',
			src4: '',
			introduceText1: '',
			introduceText2: '',
			introduceText3: '',
			introduceText4: '',
			product_list: [],
			parterList: [{ src: '' }],
			productOne_list: [],
			new_list_left:[],
			image_one:'',
			image_two:'',
			productCenter:[
				{src:'',title:'',description:'',id:''},
				{src:'',title:'',description:'',id:'d94ae80a-9c76-4d1e-a0f1-f7d8153559e5'},
				{src:'',title:'',description:'',id:''},
				{src:'',title:'',description:'',id:''},
			],
			jump:[],
			add1:'',
			add2:'',
			add3:'',
			add4:'',
			add5:'',
			add6:'',
			titleOne:'',
			titleOneEng:'',
			titleTwo:'',
			titleTwoEng:'',
			titleThree:'',
			titleThreeEng:'',
			titleFour:'',
			titleFourEng:'',
			titleFive:'',
			titleFiveEng:'',
		}
	},
	created() {
		this.init()
	},
	mounted() {
		var bannerImageList = []
		var bannerList = [],
			panter = []
		//公共接口

			Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
			for (var i = 0; i < (res.data.data.rows.length); i++) {
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'HOME_PAGE_BANNER') {
					bannerList.push(res.data.data.rows[i].sc_value)
					bannerImageList.push({src:res.data.data.rows[i].sc_value})
				}
				if (res.data.data.rows[i].sc_key.slice(0, 6) == 'PANTER') {
					panter.push(
						 res.data.data.rows[i].sc_value
					)
				}
				if (res.data.data.rows[i].sc_key.slice(0, 13) == 'HOMEINTORDUCE') {
					this.src1 =
						res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 10) == 'HOMEJOINUS') {
					this.src2 =
						res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 9) == 'HOMEVALUE') {
					this.src3 =
						 res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 13) == 'HOMECOMPANY') {
					this.src4 =
						 res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 15) == 'BANNERDETAILONE') {
					this.add1 =res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 15) == 'BANNERDETAILTWO') {
					this.add2 =res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 17) == 'BANNERDETAILTHREE') {
					this.add3 =res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'BANNERDETAILFOUR') {
					this.add4 =res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'BANNERDETAILFIVE') {
					this.add5 =res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 15) == 'BANNERDETAILSIX') {
					this.add6 =res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 13) == 'TEXTINTORDUCE') {
					this.introduceText1 = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 10) == 'TEXTJOINUS') {
					this.introduceText2 = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 9) == 'TEXTVALUE') {
					this.introduceText3 = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 11) == 'TEXTCOMPANY') {
					this.introduceText4 = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 11) == 'PERFORMANCE') {
					this.performance = res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMEPRODUCTONE') {
					this.productCenter[0].src=res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMEPRODUCTTWO') {
					this.productCenter[1].src=res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'HOMEPRODUCTTHREE') {
					this.productCenter[2].src= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 15) == 'HOMEPRODUCTFOUR') {
					this.productCenter[3].src= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 13) == 'HOMEPROTITONE') {
					this.productCenter[0].title= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 15) == 'HOMEPROTITLETWO') {
					this.productCenter[1].title= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 17) == 'HOMEPROTITLETHREE') {
					this.productCenter[2].title= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'HOMEPROTITLEFOUR') {
					this.productCenter[3].title= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMEPRODUCEONE') {
					this.productCenter[0].description= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMEPRODUCETWO') {
					this.productCenter[1].description= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'HOMEPRODUCETHREE') {
					this.productCenter[2].description= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 15) == 'HOMEPRODUCEFOUR') {
					this.productCenter[3].description= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 12) == 'HOMETITLEONE') {
					this.titleOne= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'HOMETITLEPRODUCT') {
					this.titleOneEng= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 12) == 'HOMETITLETWO') {
					this.titleTwo= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 17) == 'HOMETITLESOLUTION') {
					this.titleTwoEng= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMETITLETHREE') {
					this.titleThree= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 12) == 'HOMETITLNEWS') {
					this.titleThreeEng= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 13) == 'HOMETITLEFOUR') {
					this.titleFour= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMETITLEABOUT') {
					this.titleFourEng= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 13) == 'HOMETITLEFIVE') {
					this.titleFive= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 12) == 'HOMETITLEPAR') {
					this.titleFiveEng= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMEPROJUMPONE') {
					this.productCenter[0].id= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 14) == 'HOMEPROJUMPTWO') {
					this.productCenter[1].id= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 16) == 'HOMEPROJUMPTHREE') {
					this.productCenter[2].id= res.data.data.rows[i].sc_value
				}
				if (res.data.data.rows[i].sc_key.slice(0, 15) == 'HOMEPROJUMPFOUR') {
					this.productCenter[3].id= res.data.data.rows[i].sc_value
				}

			}
			this.parterList[0].src = panter[0]
			// bannerImageList[0].src =  bannerList[0]
			// bannerImageList[1].src = bannerList[1]
			// bannerImageList[2].src = bannerList[2]
			// bannerImageList[3].src =  bannerList[3]
			// bannerImageList[4].src =  bannerList[4]
			// bannerImageList[5].src = bannerList[5]
			this.bannerImageLi = bannerImageList
		})
		//新闻接口
		Axios({
			url: '/apiv2/bdoc/getlist?bdContenttype=新闻',
			data: {},
			method: 'GET',
		}).then((res) => {
			window.sessionStorage.setItem("newsPop",JSON.stringify(res.data.data.rows));
			this.new_list_left=res.data.data.rows.slice(0,2)
			this.image_one=this.new_list_left[0].bd_coverpicturecn
			this.image_two=this.new_list_left[1].bd_coverpicturecn
			this.new_list = res.data.data.rows.slice(2, 7)
			for (var k = 0; k < this.new_list.length; k++) {
				this.new_list[k].bd_coverpicturecn =
					this.new_list[k].bd_coverpicturecn
			}
		})
		Axios({
			url: '/apiv2/bdoctreecontent/getlist?bdContenttype=解决方案',
			data: {},
			method: 'GET',
		}).then((res) => {
			for (var m = 0; m < res.data.data.rows.length; m++) {
				if (res.data.data.rows[m].bd_treenodepid == '') {
					res.data.data.rows[m].bd_coverpicturecn =
						 res.data.data.rows[m].bd_coverpicturecn
					this.solution.push(res.data.data.rows[m])
				}
			}
			this.solution = this.solution.slice(0, 4)
		})
	},
	beforeDestroy() {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		goBannerDetail(index){
			if(index=='0'){
				this.$router.push(this.add1)
			}
			if(index=='1'){
				this.$router.push(this.add2)
			}
			if(index=='2'){
				this.$router.push(this.add3)
			}
			if(index=='3'){
				this.$router.push(this.add4)
			}
			if(index=='4'){
				this.$router.push(this.add5)
			}
			if(index=='5'){
				this.$router.push(this.add6)
			}
		},
		goPerformance(){
			window.location.href=this.performance
		},
		init() {
			if (!window.localStorage.getItem('storge')) {
				clearInterval(this.timer)
				this.timer = null
				this.timer = setTimeout(() => {
					this.isAlert = true
				}, 3000)
				window.localStorage.setItem('storge', 'true')
			}
		},
		leaving() {
			this.$router.push('/leaving')
		},
	},
}
</script>

<style lang="scss" >
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';
	.dis_flex {
		text-align: center;
	}
	.banner_container {
		.el-carousel__button {
			width: 10px !important;
			height: 10px !important;
			border-radius: 50% !important;
		}
		.el-carousel {
			margin: 0 0 20px;
			.el-carousel__container {
				height: 100vh;
			}
			.el-carousel__item img {
				width: 100%;
				height: 100%;
				cursor: pointer;
			}
		}
	}
	.news_container_x {
		.el-carousel__button {
			width: 10px !important;
			height: 10px !important;
			border-radius: 50% !important;
		}
	}
	.company_introduction_x {
		.el-carousel__button {
			height: 35px !important;
		}
	}
	.news_container_x,
	.company_introduction_x {
		.el-carousel {
			height: 415px;
			.el-carousel__container {
				height: 100%;
			}
			.el-carousel__item img {
				width: 100%;
				height: 100%;
			}
		}
	}
}
.el-carousel__indicators--labels .el-carousel__indicator {
	padding: 4px 40px !important;
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m_index.scss';
	.banner_container {
		padding: 0 rm(20);
		.el-carousel__button {
			width: 10px !important;
			height: 10px !important;
			border-radius: 50% !important;
		}
		.el-carousel {
			margin: rm(10) 0 rm(30);
			.el-carousel__container {
				height: rm(220);
			}
			.el-carousel__item img {
				width: 100%;
				height: 100%;
			}
		}
	}
	.news_container_x {
		.el-carousel__button {
			width: rm(10) !important;
			height: rm(10) !important;
			border-radius: 50% !important;
		}
	}
	.company_introduction_x {
		.el-carousel__button {
			height: rm(35) !important;
		}
	}
	.news_container_x,
	.company_introduction_x {
		.el-carousel {
			height: rm(240);
			margin-bottom: rm(20);
			.el-carousel__container {
				height: 100%;
			}
			.el-carousel__item img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}
}
</style>